import React, { useState } from "react";
import "./datatable.scss";
import CreditIssued from "./CreditIssued";
import CreditConsumed from "./CreditConsumed";
import { useCreditDashBoard_Csv } from '../../../../hooks/Refund/useCreditDashBoard_Csv';
import { toast } from 'react-toastify'; // Assuming you use react-toastify for notifications

const DataTable = ({ startDate, endDate }) => {
  const [activeTab, setActiveTab] = useState("home-tab");
  const { exportToCSV, isExporting, exportError } = useCreditDashBoard_Csv();

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const handleExportClick = async () => {
    try {
      // Determine which tab is active and export the corresponding data
      const tabType = activeTab === "home-tab" ? 'issued' : 'consumed';

      // toast.info(`Preparing ${tabType} transactions CSV...`);

      await exportToCSV(tabType, startDate, endDate);

      // Show success message
      // toast.success(`${tabType.charAt(0).toUpperCase() + tabType.slice(1)} transactions exported successfully!`);
    } catch (error) {
      toast.error(exportError || 'Failed to export CSV. Please try again.');
      console.error('CSV export error:', error);
    }
  };

  return (
    <>
      <section className="datatable">
        <div className="main-heading d-flex justify-content-between align-items-center">
          <ul className="nav nav-tabs viewdetail-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "home-tab" ? "active" : ""}`}
                id="home-tab"
                data-bs-toggle="tab"
                data-bs-target="#home-tab-pane"
                type="button"
                role="tab"
                aria-controls="home-tab-pane"
                aria-selected={activeTab === "home-tab"}
                onClick={() => handleTabClick("home-tab")}
              >
                Credits issued
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "profile-tab" ? "active" : ""}`}
                id="profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#profile-tab-pane"
                type="button"
                role="tab"
                aria-controls="profile-tab-pane"
                aria-selected={activeTab === "profile-tab"}
                onClick={() => handleTabClick("profile-tab")}
              >
                Credits consumed
              </button>
            </li>
          </ul>
          <div className="upperbtn">
            <button
              className="downloadcsvcustombutton"
              onClick={handleExportClick}
              disabled={isExporting}
            >
              {isExporting ? 'Exporting...' : activeTab === "home-tab" ? 'Download Issued Csv' : 'Download Consumed Csv'}
            </button>
          </div>
        </div>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="home-tab-pane"
            role="tabpanel"
            aria-labelledby="home-tab"
            tabIndex="0"
          >
            <CreditIssued startDate={startDate} endDate={endDate} />
          </div>
          <div
            className="tab-pane fade"
            id="profile-tab-pane"
            role="tabpanel"
            aria-labelledby="profile-tab"
            tabIndex="0"
          >
            <CreditConsumed startDate={startDate} endDate={endDate} />
          </div>
        </div>
      </section>
    </>
  );
};

export default DataTable;